export {
  B2cClaimsModule,
  routeclaimsinsurance,
  øB2cClaimsModule,
} from './b2c-claims.module';
export { StarterService } from './starter.service';
export { CoreServiceModule } from './core/core-service.module';
export { B2cClaimsData } from './model/B2cClaimsData';
export { ClaimsSerializedData } from './model/B2cClaimsData';